// extracted by mini-css-extract-plugin
export default {"submit_btn":"UserData_submit_btn__mGxjo","buttons":"UserData_buttons__+c71F","buttonOptions":"UserData_buttonOptions__nJa8O"};